import { render, staticRenderFns } from "./createAlltarefe.vue?vue&type=template&id=b86024fc"
import script from "./createAlltarefe.vue?vue&type=script&lang=js"
export * from "./createAlltarefe.vue?vue&type=script&lang=js"
import style0 from "./createAlltarefe.vue?vue&type=style&index=0&id=b86024fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports